/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Create_SubmitInputs */

const en_admin_invite_codes_create_submit = /** @type {(inputs: Admin_Invite_Codes_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create`)
};

const zh_admin_invite_codes_create_submit = /** @type {(inputs: Admin_Invite_Codes_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建`)
};

/**
* | output |
* | --- |
* | "Create" |
*
* @param {Admin_Invite_Codes_Create_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_create_submit = /** @type {((inputs?: Admin_Invite_Codes_Create_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Create_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_create_submit(inputs)
	return zh_admin_invite_codes_create_submit(inputs)
});
export { admin_invite_codes_create_submit as "admin.invite_codes.create_submit" }